import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AuthContext } from "./context/AuthContext";
import StorePage from "./page/StorePage/StorePage";
import { useState } from "react";
import ErrorBoundary from "./page/component/ErrorBoundary";
import LoginPage from "./page/LoginPage/LoginPage";
import "./css/App.css";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Navigate,
} from "react-router-dom";

const theme = createTheme({
  palette: {
    primary: {
      main: "#E3B505", // black
    },
    secondary: {
      main: "#ffffff", // white
    },
    button:{
      main:"#E3B505",
    },
    background: {
      default: "#EEEEEE",
      secondary: "#ffffff",
      gray: "#DEDEDE",
      component: "#ffffff",
    },
    text: {
      primary: "#000000",
      secondary: "#787878",
      selected: "#98B147",
    },
    warning: {
      light: "#ffd166", // your light warning color
      main: "#3D3C35", // your main warning color
      dark: "#d06600", // your dark warning color
      contrastText: "#fff", // text color that will contrast with the warning color
    },
    selected: "#E3B505",
  },
});
const isManageSubdomain = window.location.hostname.startsWith("console.");

const userRoutes = createRoutesFromElements([
  <Route errorElement={<ErrorBoundary />}>
    <Route path="/app" element={<></>} />
    <Route path="/app/store/:storeId" element={<StorePage />} />
    <Route path="/app/store/:storeId/:tableNo" element={<StorePage />} />

  </Route>,

  
]);

const adminRoutes = createRoutesFromElements([
  <Route path="/login" element={<LoginPage />} />,
  <Route path="/dashboard" element={<></>}></Route>,
  <Route errorElement={<ErrorBoundary />} />,
]);
const router = createBrowserRouter(
  isManageSubdomain ? adminRoutes : userRoutes
);
function App() {
  const [user, setUser] = useState(null);

  return (
    <ThemeProvider theme={theme}>
      <AuthContext.Provider
        value={{
          user: user,
          setUser: setUser,
        }}
      >
        <RouterProvider router={router} />
      </AuthContext.Provider>
    </ThemeProvider>
  );
}

export default App;
